module.exports = __webpack_public_path__ + "static/img/hire@2x.beb835a1.png";